export default "__VITE_ASSET__B6nJ5g4j__"